// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","borderRed":"#ffb9b9","textBlack":"#161616","textGrey":"#3f3f3f","caption":"_1dJD2pSCq2-UhXWE_3mRfd","extraSmallMaxWidth":"767px","container":"_2WameHdWHLJN3rsFGJfu2K","nameContainer":"Ibq07Uf2iW-18msBoPJvj","subtitle":"_1GjOeEZPOAaFY-nOeQgKD7 _1dJD2pSCq2-UhXWE_3mRfd","name":"_3FVa2ffUT68JRdwj1TnYIU _1dJD2pSCq2-UhXWE_3mRfd","actionContainer":"yHZsIKh9XjvULpmfoKV5O","undoButton":"_4-dC1A_5FB3i_8KxFjcad _1dJD2pSCq2-UhXWE_3mRfd"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/cart/deleted-product-card/DeletedProductCard.css
// module id = 411
// module chunks = 0 1 2